export default "__VITE_PUBLIC_ASSET__d4d7063d__"